
import { Link } from "react-router-dom";
import { getCurrentUser } from "../../lib/auth_base/localstorage";
import ChangeForm from "./change-form";

//

//
export default  function ChangePasswordDetail() {
  const user = getCurrentUser();

  return (
    <>
      <div className="dashboard-page-title">
        <div className="breadcrumbs">
          <Link to="/admin">Dashboard</Link>
          <span>Change Password</span>
        </div>
      </div>

  <ChangeForm user={user} />
    </>
  );
}
